export default "<p>logout works!</p>\r\n";